import React, { useEffect, useRef, useState } from 'react';
import NotificationItem from '../NotificationItem';
import Button from '../../Button';
import { useNavigate } from 'react-router-dom';
import {
  NotificationWrapper,
  Dropdown,
  ButtonsContainer,
  TopBar,
} from './NotificationDropDown.styled';
import { ASSETS } from '../../../utils/config';
import { LeftBar, NotificationCount, IconButton } from '../../../pages/Notifications/styles';
import TextView from '../../TextView';
import MoreVertIcon from '@mui/icons-material/MoreVert'; // For the three dots
import { Button as MuiButton } from '@material-ui/core';
import { colors } from '../../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { setNotifications } from '../../../redux/reducers/notifications';
import { markAllRead } from '../../../services/api';
import NotificationsEmptyState from '../EmptyState';

function NotificationDropdown({ onClose }) {
  // const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const notifications = useSelector((state) => state.notifications.data) ?? [];
  const dispatch = useDispatch();
  const [unreadCount, setUnreadCount] = useState(0); // State to track unread notifications
  const handleMarkRead = async () => {
    // Mark all notifications as read
    // setNotifications((prevNotifications) =>
    //   prevNotifications.map((notification) => ({ ...notification, is_read: true }))
    // );
    try {
      const response = await markAllRead();
      console.log('Read response:', response);

      if (response.data && response.data.success) {
        // console.log('success')
        dispatch(
          setNotifications(
            notifications.map((notification) => ({ ...notification, is_read: true }))
          )
        );
        setUnreadCount(0);
      } else {
        console.warn('/marking failed:', response.data);
      }
    } catch (error) {
      console.error('Error marking as read:', error.response ? error.response.data : error.message);
    }
  };
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       onClose(); // Close the dropdown when clicking outside
  //     }
  //   };
  //   setUnreadCount(notifications.filter((notification) => !notification.is_read).length);

  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => {
  //     document.removeEventListener('mousedown', handleClickOutside);
  //   };
  // }, [onClose]);

  return (
    <Dropdown>
      <TopBar>
        <LeftBar>
          <TextView variant="subTitle" style={{ fontWeight: 'bold' }}>
            Notifications
          </TextView>
          <NotificationCount>{unreadCount}</NotificationCount>
        </LeftBar>

        {/* <IconButton>
            <MarkAsUnreadIcon /> 
          </IconButton> */}
        <IconButton>
          <MoreVertIcon />
        </IconButton>
      </TopBar>
      {notifications?.length ? <NotificationWrapper>
        {notifications?.slice(0, 4).map((notification) => (
          <NotificationItem
            key={notification?.id}
            name={notification?.name}
            image={notification?.profile_picture}
            wheel={notification?.image}
            text={notification?.description || notification?.title}
            type={notification?.type}
            wheelName={notification?.wheelName}
            time={notification?.time_ago}
            isUnread={!notification?.is_read}
            isDropDown={true}
            wheelId={notification?.ref_id}
          // wheel={notification.image}
          />
        ))}
      </NotificationWrapper>
        : <NotificationsEmptyState />}
      <ButtonsContainer>
        <muiButton variant="text">
          <TextView
            style={{ color: '#123051', cursor: 'pointer' }}
            variant="largeText"
            onClick={handleMarkRead}
          >
            {' '}
            Mark all as read{' '}
          </TextView>
        </muiButton>
        <Button
          style={{ backgroundColor: colors.purple }}
          onClick={() => navigate('/notifications')}
        >
          View All
        </Button>
      </ButtonsContainer>
    </Dropdown>
  );
}

export default NotificationDropdown;
